// usePageSize — read the shared rows-per-page preference, and re-render when it
// changes anywhere in the app (a list can be open in one tab of the UI while the
// selector is changed on another screen; both should agree).
//
// See src/services/pageSize.ts for why this is per-device and shared across every
// list rather than per-screen or per-account.

import React from "react";
import { getPageSize, setPageSize, subscribeToPageSize } from "../services/pageSize";

export function usePageSize(): [number, (value: unknown) => void] {
  const [size, setSize] = React.useState(getPageSize);
  React.useEffect(function () {
    // Sync in case the value changed between first render and subscribing.
    setSize(getPageSize());
    return subscribeToPageSize(setSize);
  }, []);
  return [size, setPageSize];
}
